/**
 * Returns a function to fetch results
 * @param apiUrl string
 * @returns {{fetchResults: (function(*, *, string=): Promise<any>)}} function
 */
export function useResults(apiUrl) {
    /**
     * @param q string
     * @param page integer
     * @param tag
     */
    const fetchResults = async (q, page, tag = '') => {
        const url = `${apiUrl}&q=${encodeURIComponent(q)}&page=${page}&tag=${tag}`
        const apiResponse = await fetch(url);
        return apiResponse.json()
    }
    return {fetchResults};
}

